module.exports = __webpack_public_path__ + "img/caminito-rey-1.f5559560.jpg";